import { useContext } from "react";
import AppToastContext from "./AppToast.context";

const useAppToast = () => useContext(AppToastContext);

export default useAppToast;
